export class Event {
  private name: string = ''
  private data: any
  private isStoppedFlag: boolean = false

  constructor(name: string) {
    this.name = name
  }

  public setData(newData: any): void {
    this.data = newData
  }

  public getData(): any {
    return this.data
  }

  public stopImmediatePropagation(): void {
    this.isStoppedFlag = true
  }

  public isStopped(): boolean {
    return this.isStoppedFlag
  }
}
